import { KeyValue } from '@angular/common';
import { environment } from '@environments/environment';

export const SITE_NAME = 'PRO Meble';
export const SITE_URL = environment.siteUrl;
export const SITE_LOGO = `${SITE_URL}/assets/images/pro-meble-logo-1200.jpg`;
export const DEFAULT_SITE_TITLE = 'PRO Meble - Zabudowy meblowe na wymiar';
export const DEFAULT_SITE_DESCRIPTION = 'Wykonujemy zabudowy meblowe na wymiar. Tworzymy indywidualne projekty mebli wraz z wizualizacją. Profesjonalnie i terminowo.';
export const DEFAULT_SITE_KEYWORDS = 'zabudowy meblowe na wymiar, meble na wymiar, kuchnie na wymiar, szafy na wymiar, fronty meblowe, fronty lakierowane, montaż mebli, projekt kuchni, projekt szafy, projekt mebli';

export interface OgImage {
  url: string;
  alt: string;
}

export enum OgType {
  Website = 'website',
  Article = 'article',
  Book = 'book',
  Profile = 'profile',
  PaymentLink = 'payment.link',
  MusicSong = 'music.song',
  MusicAlbum = 'music.album',
  MusicPlaylist = 'music.playlist',
  MusicRadioStation = 'music.radio_station',
  VideoMovie = 'video.movie',
  VideoEpisode = 'video.episode',
  VideoTvShow = 'video.tv_show',
  VideoOther = 'video.other'
}

export enum TwitterCardType {
  Summary = 'summary',
  SummaryLargeImage = 'summary_large_image',
  App = 'app',
  Player = 'player'
}

export interface SeoData {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: OgImage;
  ogType?: OgType;
  ogUrl?: string;
  twitterCardType?: TwitterCardType;
  twitterLabel?: KeyValue<string, string>;
  twitterLabel2?: KeyValue<string, string>;
}
